import { useEffect, useState } from 'react';
import { profileApi } from '../../../shared/api/profileApi';

export function usePreferredBible() {
  const [preferredBible, setPreferredBible] = useState<string>('en-kjv');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getPreferredBible() {
      try {
        const { bible, error } = await profileApi.getPreferredBible();
        if (error) throw error;
        if (bible) {
          setPreferredBible(bible);
        }
      } catch (error) {
        console.error('Error loading preferred Bible:', error);
      } finally {
        setLoading(false);
      }
    }

    getPreferredBible();
  }, []);

  return { preferredBible, loading };
}